export const NOTIFICATION_TYPE = {
  GENERAL_NOTICE: 0, // 공지사항
  MESSAGE: 1, // 메시지
  ORG_REVIEW: 2, // 기관 리뷰 요청
  USER_REVIEW: 3, // 유저 리뷰 요청
  FORM: 4, // 폼 작성 알림
  PAYMENT: 5, // 결제일이 도래했음을 알려주는 알림
};

export const NOTIFICATION_TYPE_STRING = [
  "공지사항",
  "메시지",
  "기관심사요청",
  "유저심사요청",
  "서식작성알림",
  "결제필요"
];